import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, FormControlLabel, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import FileUpload from '../../../controls/FileUpload';
import { withAuthenticationContext } from '../../../Authenticate/index';
import { apiPost } from '../../../api';
import { compose } from 'redux';

const styles = (theme) => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
    },
    greyWithPadding: {
        paddingTop: theme.spacing(4),
        color: grey[600],
    },
    rowsGrid: {
        alignItems: 'center',
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
    rowsHeading: {
        fontWeight: 'bold',
        color: '#484848',
    },
});
class FileUploadDetails extends React.Component {
    state = {
        errorMessage: null,
        isLoading: false,
        fileName: '',
    };

    handleIsSmartUpload = (event) => {
        const target = {
            id: 'smartUpload',
            value: event.target.checked,
        };
        this.props.handleChange({ target });
    };

    handleSmartTemplateUpload = async (files) => {
        if (files.length > 1) {
            this.setState({
                errorMessage: 'Only one template can be uploaded',
            });
        } else {
            this.setState({
                isLoading: true,
            });
            let file = files[0];
            let data = new FormData();
            data.append(
                'file',
                new File([file], file.name, {
                    type: file.type,
                }),
            );
            data.append('documenttype', file.type);
            let updatedTemplate = {};

            const scopes = this.props.authorizationScopes.forms;
            const tokenPromise = scopes ? this.props.getAccessToken(scopes) : Promise.resolve(undefined);
            tokenPromise
                .then((token) => {
                    return apiPost(`/forms/${this.props.form.id}/attachments`, data, token);
                })
                .then((result) => {
                    const response = result.data;
                    updatedTemplate = { ...this.props.field?.template, name: file.name, id: response[0].id };
                    this.setState({
                        isLoading: false,
                    });
                    const target = {
                        id: 'template',
                        value: updatedTemplate,
                    };
                    this.props.handleChange({ target });
                })
                .catch();
        }
    };

    handleSmartTemplateDelete = () => {
        const templateValue = { ...this.props.field?.template, id: null, name: null };
        const target = {
            id: 'template',
            value: templateValue,
        };
        this.props.handleChange({ target });
    };

    handleSetScore = (event) => {
        const templateValue = {
            ...this.props.field?.template,
            scoreThreshold:
                isNaN(event.target.value) || event.target.value === ''
                    ? event.target.value
                    : parseFloat(event.target.value),
        };
        const target = {
            id: 'template',
            value: templateValue,
        };
        this.props.handleChange({ target });
    };

    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="instructions"
                            label="Field Instructions"
                            value={this.props.field.instructions}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            multiline
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            id="label"
                            label="Field Label"
                            value={this.props.field.label}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            label={<Typography className={this.props.classes.grey}>Use Smart Upload</Typography>}
                            control={
                                <Checkbox
                                    id={'smartUpload'}
                                    name={'smartUpload'}
                                    checked={this.props.field?.smartUpload}
                                    key={'smartUpload'}
                                    color={'primary'}
                                    className={this.props.classes.checkbox}
                                    onChange={(e) => this.handleIsSmartUpload(e)}
                                />
                            }
                        />
                    </Grid>
                    {this.props.field?.smartUpload === true && (
                        <>
                            <Grid container className={this.props.classes.rowsGrid} spacing={4}>
                                <Grid item xs={5}>
                                    <Typography className={this.props.classes.rowsHeading} variant="subtitle1">
                                        Comparison Template
                                    </Typography>
                                    <Typography>Template to compare against when validating user input</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <FileUpload
                                        onUpload={this.handleSmartTemplateUpload}
                                        onDelete={this.handleSmartTemplateDelete}
                                        isLoading={this.state.isLoading}
                                        selectedFile={this.props.field?.template}
                                        disabled={this.props.field?.template?.id}
                                        errorMessage={this.state.errorMessage}
                                        smartUpload={this.props.field?.smartUpload}
                                    ></FileUpload>
                                </Grid>
                            </Grid>
                            <Grid container className={this.props.classes.rowsGrid} spacing={4}>
                                <Grid item xs={5}>
                                    <Typography className={this.props.classes.rowsHeading} variant="subtitle1">
                                        Similarity Score
                                    </Typography>
                                    <Typography>
                                        Percentage amount that user input must match template file in order to be
                                        considered valid
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <TextField
                                        id="score"
                                        label="Percentage"
                                        value={this.props.field?.template?.scoreThreshold}
                                        margin="normal"
                                        variant="outlined"
                                        style={{ width: 225 }}
                                        className={this.props.classes.whiteBackground}
                                        onChange={(e) => this.handleSetScore(e)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            id="additionalInfo"
                            label="Additional Information"
                            multiline
                            rows={4}
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            value={this.props.field.additionalInfo}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}
export default compose(withStyles(styles), withAuthenticationContext)(FileUploadDetails);
